import { useCallback, useState, useEffect, memo } from 'react';
import { BzModal, BzModalHeader, BzModalBody } from '../../components';
import { handleModal } from "../../redux/actions/modals";
import { useDispatch, useSelector } from 'react-redux';
import { MarketOverview, MarketOverviewHeader } from '../../containers';
import { GLOBAL_FUNCTION_TYPES, MARKET_OVER_VIEW_TAB_KEYS, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { setIsIndicesOverview } from '../../redux/actions/indices';
import { sendBestFiveRequest, sendTouchlineRequest } from '../../apis/web_socket';
import { createChartUrl, globalFunctionsEventDispatcher, isUserIsAGuest } from '../../utils/global_functions';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';
import { clearOptionChain, openOptionChain, updateLegDataForOptionChain, updateOptionChainLastTick } from '../../redux/actions/optionChain';
import { updateSelectedArrRowData } from '../../redux/actions/marketOverview';


function MarketOverviewModal({ setActiveButtonToggleIndex, ...props }) {

  const { setSingleOrder, layoutType } = props;
  const dispatch = useDispatch();
  const marketDepthData = useSelector(state => state.marketOverview.marketDepth);
  //Prachi Tawde 02-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
  const isIndicesOverview = useSelector(state => state.indices.isIndicesOverview);
  const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
  const objOptionChainPayload = useSelector(state => state?.optionChain?.objOptionChainPayload);
  const objOptionChainLastStack = useSelector(state => state?.optionChain?.objOptionChainLastStack);


  const [expandScripOverviewModel, setExpandScripOverviewModel] = useState(false);
  const [selectedTab, setSelectedTab] = useState('overview');
  const chartAttributes = useSelector(state => state.appInfo.chartAttributes);
  const [chartURL, setChartURL] = useState("");
  const [chartOpened, setChartOpened] = useState(false);
  const [lastTab, setLastTab] = useState();
  const modals = useSelector(state => state?.modals?.modals);
  const objScripsRequested = useSelector(state => state?.optionChain?.objScripsRequested);
  const [spinner, setSpinner] = useState(false);


  useEffect(() => {
    if (selectedTab !== MARKET_OVER_VIEW_TAB_KEYS?.OPTION_CHAIN && Object?.keys(objScripsRequested)?.length > 0) {
      if (Object?.keys(objScripsRequested)?.length > 0) {
        let arrDataToUnsubScribe = Object?.keys(objScripsRequested)?.map((eachToken) => {
          return { exchangeId: Number(eachToken?.split("_")[0]), token: Number(eachToken?.split("_")[1]), isSubscribe: false };
        });
        sendTouchlineRequest(arrDataToUnsubScribe);
      }
    } else { }
  }, [selectedTab, objScripsRequested]);


  /* Deepti B BT-107426 last visisted tab will open of chartOpened is false */
  useEffect(() => {
    if (chartOpened) {
      setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS.CHART);
    } else { }
    if (lastTab) {
      setSelectedTab(lastTab);
    } else { }
  }, [chartOpened, lastTab]);

  const handleMarketOverviewExpandOnclick = useCallback(() => {
    if (expandScripOverviewModel) {
      setExpandScripOverviewModel(false);
      globalFunctionsEventDispatcher([GLOBAL_FUNCTION_TYPES.COLLASPSING_MARKET_OVERVIEW]);
    }
    else {
      globalFunctionsEventDispatcher([GLOBAL_FUNCTION_TYPES.EXPANDING_MARKET_OVERVIEW]);
      setExpandScripOverviewModel(true);
    }
  }, [expandScripOverviewModel]);
  //Vaibhav Singh : BT-107400 : handle function for chart component
  const getEvent = useAnalyticsEventTracker('OVERVIEW');
  const handleChart = useCallback(() => {
    // check if option chain is active or not
    if (selectedTab === MARKET_OVER_VIEW_TAB_KEYS?.OPTION_CHAIN) {
      dispatch(updateOptionChainLastTick({ ...objOptionChainPayload }));
    }
    getEvent('CHART_SCRIPINFO');
    if (!isUserIsAGuest('chart')) {
      setChartURL(createChartUrl(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
      setChartOpened(prevState => !prevState);
    } else { }
  }, [selectedTab, chartAttributes, getEvent, scripOverviewData, objOptionChainPayload, dispatch]);

  const handleClose = useCallback(() => {
    setChartOpened(false); //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
    if (lastTab !== undefined) {
      if (lastTab === MARKET_OVER_VIEW_TAB_KEYS?.OPTION_CHAIN) {
        dispatch(openOptionChain({ ...objOptionChainLastStack }));
        dispatch(updateOptionChainLastTick({}));
      }
      setSelectedTab(lastTab);
    } else {
      setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.OVERVIEW);
    }
  }, [lastTab, objOptionChainLastStack, dispatch]);
  useEffect(() => {
    if (isIndicesOverview) {
      setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.CONSTITUENTS);
    } else { }
  }, [isIndicesOverview]);



  //Ameersha N  -- To unsubscribe all data when closing market overview modal if option is opened -- Start
  const unsubScribOptionChainData = useCallback(() => {
    return new Promise((resolve) => {
      if (Object?.keys(objScripsRequested)?.length > 0) {
        let arrDataToUnsubScribe = Object?.keys(objScripsRequested)?.map((eachToken) => {
          return { exchangeId: Number(eachToken?.split("_")[0]), token: Number(eachToken?.split("_")[1]), isSubscribe: false };
        });
        sendTouchlineRequest(arrDataToUnsubScribe);
        globalFunctionsEventDispatcher([GLOBAL_FUNCTION_TYPES.CLOSING_OPTION_CHAIN]);
      }
      resolve(true);
    });


  }, [objScripsRequested]);
  //Ameersha N  -- To unsubscribe all data when closing market overview modal if option is opened -- End

  const onHide = () => {
    dispatch(updateSelectedArrRowData([]));
    dispatch(updateLegDataForOptionChain());
    dispatch(clearOptionChain());
    unsubScribOptionChainData(); //Ameersha N  -- To unsubscribe all data when closing market overview modal if option is opened
    setChartOpened(false);
    dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }], true));
    setExpandScripOverviewModel(false);
    //Prachi Tawde 01-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
    dispatch(setIsIndicesOverview(false));
    isIndicesOverview ? setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.CONSTITUENTS) : setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.OVERVIEW);
  };

  const onExiting = () => {
    dispatch(updateSelectedArrRowData([]));
    dispatch(updateLegDataForOptionChain());
    dispatch(clearOptionChain());
    setChartOpened(false);
    unsubScribOptionChainData();//Ameersha N  -- To unsubscribe all data when closing market overview modal if option is opened
    //Prachi Tawde 01-08-2023 BT-104813 Breeze - Dashboard - Indices - Start
    dispatch(setIsIndicesOverview(false));
    setExpandScripOverviewModel(false);
    isIndicesOverview ? setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.CONSTITUENTS) : setSelectedTab(MARKET_OVER_VIEW_TAB_KEYS?.OVERVIEW);
  };

  useEffect(() => {
    if (scripOverviewData?.length > 0) {
      const objSubsScrip = { exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true };
      sendBestFiveRequest(objSubsScrip);
      return () => sendBestFiveRequest({ ...objSubsScrip, isSubscribe: false });
    } else { }
  }, [scripOverviewData]);

  return (
    //BT-113338 Implementing header changes ManasaB : 15/07/2023 Added disableEscapeKey

    < BzModal className='modal-scripinfo' disableEscapeKey={true} centered size={expandScripOverviewModel ? 'fullscreen' : 'xl'} show={modals['MARKET_OVERVIEW_MODAL']} onHide={onHide} onExiting={onExiting} >
      {modals['MARKET_OVERVIEW_MODAL'] &&
        <BzModalHeader className='pb-0'>
          <MarketOverviewHeader isSpinner={setSpinner} unsubScribOptionChainData={unsubScribOptionChainData} layoutType={layoutType} selectedTab={selectedTab} setSelectedTab={setSelectedTab} expandScripOverviewModel={expandScripOverviewModel} setExpandScripOverviewModel={setExpandScripOverviewModel} handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick} marketDepthHeaderData={marketDepthData} isIndicesOverview={isIndicesOverview} setLastTab={setLastTab} chartOpened={chartOpened} handleChart={handleChart} />
        </BzModalHeader>}
      {modals['MARKET_OVERVIEW_MODAL'] &&
        <BzModalBody className='modal-body-shadow'>
          <MarketOverview
            chartOpened={chartOpened}
            spinner={spinner}
            chartURL={chartURL}
            handleClose={handleClose}
            setSingleOrder={setSingleOrder}
            handleMarketOverviewExpandOnclick={handleMarketOverviewExpandOnclick}
            expandScripOverviewModel={expandScripOverviewModel}
            setExpandScripOverviewModel={setExpandScripOverviewModel}
            marketDepth={marketDepthData}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            isIndicesOverview={isIndicesOverview}
            setActiveButtonToggleIndex={setActiveButtonToggleIndex}
          />
        </BzModalBody>}
    </BzModal >

  );
}

export default memo(MarketOverviewModal);